var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup231331(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#606060;stroke-width:1.5px;}.b,.d{fill:none;}.b{stroke:#707070;stroke-linecap:round;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-961 -665)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(961 665)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 13,
    height: 13,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.75,
    y: 0.75,
    width: 11.5,
    height: 11.5,
    rx: 1.25
  })), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 6,
    transform: "translate(964.5 669.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 4,
    transform: "translate(964.5 671.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 2,
    transform: "translate(964.5 673.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup231331);
export default __webpack_public_path__ + "static/media/Group 231331.7fe264f01bc7f799affce3d0dd0f9485.svg";
export { ForwardRef as ReactComponent };